import Env from '../../base/env';
import Component from 'gia/Component';
import gsap from 'gsap'
import easesCustom from '../../fx/CustomEases';
import { ScrollTrigger } from '../../vendor/gsap-bonus-umd/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class FxModule extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.separator = this.DOM.view.querySelector('.fxSeparator')
    this.DOM.cta = this.DOM.view.querySelectorAll('.fxCta')
    this.DOM.texts = this.DOM.view.querySelectorAll('.fxText')
    this.DOM.textsB = this.DOM.view.querySelectorAll('.fxTextB')
    this.DOM.picture = this.DOM.view.querySelector('.fxPicture')
    this.DOM.visual = this.DOM.view.querySelectorAll('.fxVisual')
    //? Fns
    setTimeout(() => {
      this._fx()
    }, Env.timingDelayFx);
  }

  _fx()
  {
    this.animate()
    this.reveal()
  }

  animate()
  {
    this.animation = gsap.timeline()

    this.animation
    .add([
      gsap.fromTo(
        this.DOM.separator,
        {
          scaleX:0,
          transformOrigin:'left top'
        },
        {
          scaleX:1,
          ease:easesCustom.quart,
          duration:.7
        }
      ),
      gsap.fromTo(
        this.DOM.texts,
        {
          autoAlpha:0,
          y:30
        },
        {
          autoAlpha:1,
          y:0,
          ease:easesCustom.cubic,
          duration:.7,
          stagger:.2
        }
      ),
    ])
    .add([
      gsap.fromTo(
        this.DOM.textsB,
        {
          autoAlpha:0,
          y:30
        },
        {
          autoAlpha:1,
          y:0,
          ease:easesCustom.cubic,
          duration:.7,
          stagger:.2
        }
      ),
      gsap.fromTo(
        this.DOM.picture,
        {
          autoAlpha:0
        },
        {
          autoAlpha:1,
          ease:easesCustom.quart,
          duration:1.2,
          delay:.2
        }
      ),
      gsap.fromTo(
        this.DOM.visual,
        {
          autoAlpha:1,
          scale:1.2
        },
        {
          immediateRender:false,
          scale:1.01,
          ease:easesCustom.quart,
          duration:1.4,
        }
      ),
    ])

    gsap.fromTo(
      this.DOM.cta,
      {
        autoAlpha:0
      },
      {
        autoAlpha:1,
        ease:easesCustom.cubic,
        duration:.8,
        scrollTrigger:{
          trigger:this.DOM.cta,
          start:'top 90%'
        }
      }
    )
  }

  reveal()
  {
    const offsetStart = (Env.mobileCSS)?'top 70%':'top 50%';
    this.st = ScrollTrigger.create({
      animation:this.animation,
      trigger:this.DOM.view,
      start:offsetStart
    })
  }

  unmount()
  {
    this.st.kill(true)
  }
}
